import { Type } from 'class-transformer';
import { IsArray, IsEnum, IsIn, IsInt, IsOptional, IsString, IsUUID, Min } from 'class-validator';
import { MarketStatus } from '../../enums/market-status.enum';

export class MarketDto {
	id: string;
	created_by: string;
	event_id: string;
	question: string;
	initial_value: number;
	current_value?: number;
	priority?: number;
	second_chance_priority?: number;
	h2h_priority?: number;
	status?: MarketStatus;
	start_date: Date;
	created_date?: Date;
	opening_time?: Date;
	closing_date?: Date;
	settled_date?: Date;
	trade_start_at?: Date;
	match_id?: string;
	category_id?: string;
	context?: string;
	ext_api_market_id?: string;
	ext_api_market?: string;
	ext_api_name?: string;
	is_settle_at_end?: boolean;
	is_second_chance?: boolean;
	updated_odds_date?: Date;
	stat_threshold?: number;
	stat_current?: number;
}

export enum MarketSortField {
	CreatedDate = 'created_date',
	Priority = 'priority',
	ClosingDate = 'closing_date',
	OpeningTime = 'opening_time',
}

export enum SortDirection {
	Asc = 'asc',
	Desc = 'desc',
}

export const MAX_MARKETS_PAGE_SIZE = 50;

export class GetMarketsListDto {
	@IsUUID()
	eventId: string;

	@IsOptional()
	@IsUUID()
	lobbyId?: string;

	@IsOptional()
	@IsUUID()
	slateId?: string;

	@IsOptional()
	@IsUUID()
	matchId?: string;

	@IsOptional()
	@IsIn([...Object.values(MarketStatus), 'all'])
	status?: MarketStatus | 'all';

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	marketGroups?: string[];

	@IsOptional()
	@IsEnum(MarketSortField)
	sortBy?: MarketSortField;

	@IsOptional()
	@IsEnum(SortDirection)
	sortDirection?: SortDirection;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	page?: number;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	pageSize?: number;
}
